import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetView} from '../http/views.http'
import {QUERY_KEYS} from '@/queryClient'
import {View} from '../types'
import {raise} from '@/utilities/helpers'

export const useGetView = (id: string | null, options?: Omit<UseQueryOptions<View>, 'queryKey' | 'queryFn'>) => {
    return useQuery({
        queryKey: [QUERY_KEYS.VIEW, id],
        queryFn: () => httpGetView({urlParams: {id: id ?? raise('id is nullish')}}),
        ...options
    })
}
